import IconCustomLink from '@assets/activeButton/customLink.svg';
import IconCustomURL from '@assets/activeButton/customURL.svg';
import IconShowBlock from '@assets/activeButton/openBlock.svg';
import IconOpenPage from '@assets/activeButton/openPage.svg';
import IconOpenProduct from '@assets/activeButton/openProduct.svg';
import IconScrollToBlock from '@assets/activeButton/scrollToBlock.svg';

export const CTA_TYPE = {
  block: 'block',
  heading: 'heading',
};

export const ACTION_TYPES = {
  urlCustom: 'url-custom',
  urlLink: 'url-link',
  navigationPage: 'navigate-page',
  navigationProduct: 'navigate-product',
  navigationBlock: 'navigate-block',
  actionProduct: 'modal-product',
  actionBlock: 'modal-block',
  actionItem: 'modal-item',
};

export const ACTION_CTA_TYPES_LESS = {
  link: 'link',
  url: 'url',
  openInApp: 'openInApp',
  downloadDocument: 'downloadDocument',
  sendEmail: 'sendEmail',
  phoneCall: 'phoneCall',
  openPage: 'openPage',
  openProduct: 'openProduct',
  showNewModal: 'showNewModal',
  showProduct: 'showProduct',
};

export const ACTION_CTA_TYPES = {
  ...ACTION_CTA_TYPES_LESS,
  openBlog: 'openBlog',
  openBlock: 'openBlock',
  openItem: 'openItem',
  showBlog: 'showBlog',
  showBlock: 'showBlock',
  showItem: 'showItem',
  scrollToBlock: 'scrollToBlock',
  scrollToItem: 'scrollToItem',
};
const ACTIONS_WITH_PAGE = [ACTION_CTA_TYPES.showBlock, ACTION_CTA_TYPES.showItem, ACTION_CTA_TYPES.scrollToBlock, ACTION_CTA_TYPES.scrollToItem];

export const ACTION_CTA_TYPES_HAS_OBJECT_VALUES = {
  link: ACTION_CTA_TYPES.link,
  openPage: ACTION_CTA_TYPES.openPage,
  openProduct: ACTION_CTA_TYPES.openProduct,
  showNewModal: ACTION_CTA_TYPES.showNewModal,
  showProduct: ACTION_CTA_TYPES.showProduct,
  openBlog: ACTION_CTA_TYPES.openBlog,
  openBlock: ACTION_CTA_TYPES.openBlock,
  openItem: ACTION_CTA_TYPES.openItem,
  showBlog: ACTION_CTA_TYPES.showBlog,
  showBlock: ACTION_CTA_TYPES.showBlock,
  showItem: ACTION_CTA_TYPES.showItem,
  scrollToBlock: ACTION_CTA_TYPES.scrollToBlock,
  scrollToItem: ACTION_CTA_TYPES.scrollToItem,
};

export const URL_REDIRECT = [
  {
    id: 1,
    title: 'customUrl', // title of field from translation.activeButton.customUrl
    text: 'customUrlText', // title of field from translation.activeButton.customUrlText
    icon: IconCustomURL,
    type: ACTION_TYPES.urlCustom,
  },
  {
    id: 2,
    title: 'links',
    text: 'linksText',
    icon: IconCustomLink,
    type: ACTION_TYPES.urlLink,
  },
];

export const NAVIGATION = [
  {
    id: 1,
    title: 'openPage',
    text: 'openPageText',
    icon: IconOpenPage,
    type: ACTION_TYPES.navigationPage,
  },
  {
    id: 2,
    title: 'openProduct',
    text: 'openProductText',
    icon: IconOpenProduct,
    type: ACTION_TYPES.navigationProduct,
  },
  {
    id: 3,
    title: 'scrollToBlock',
    text: 'scrollToBlockText',
    icon: IconScrollToBlock,
    type: ACTION_TYPES.navigationBlock,
  },
];

export const ACTION = [
  {
    id: 1,
    title: 'showProduct',
    text: 'showProductText',
    icon: IconOpenProduct,
    type: ACTION_TYPES.actionProduct,
  },
  {
    id: 2,
    title: 'showBlock',
    text: 'showBlockText',
    icon: IconShowBlock,
    type: ACTION_TYPES.actionBlock,
  },
  // {
  //   id: 3,
  //   title: 'showItem',
  //   text: 'showItemText',
  //   icon: IconShowItem,
  //   type: ACTION_TYPES.actionItem,
  // },
];

export const ACTION_TYPES_DATA = [...URL_REDIRECT, ...NAVIGATION, ...ACTION];

// Block types that contain a list of selectable items (for scrollToItem / openItem / showItem actions).
// Add a block type value here when the block's content has an items array supported by cta-helper/items API.
export const BLOCKS_WITH_ITEMS = [
  'link', // LinksUI — links[]
  'data-collect', // DataCollectUI — items[]
  'contact', // ContactsUI — contacts[]
  'faq', // FaqUI — faqs[]
  'trust', // TrustUI — items[]
  'feature', // FeaturesUI — items[]
  'highlight', // HighlightsUI — items[]
  'blog', // BlogUI — items[]
  'map', // MapUI — items[]
  'shop', // ShopUI — items[] (products)
  'digital', // DigitalUI — items[]
  'appointment', // AppointmentUI — items[]
  'event', // EventUI — items[]
  'membership', // MembershipUI — items[]
  'nft', // NftUI — items[]
  'wallet', // WalletUI — items[]
  'tiktok', // TikTokUI — items[]
  'youtube', // YouTubeUI — items[]
  'music', // MusicUI — items[]
  'review', // ReviewUI — items[]
  'coupon', // CouponUI — items[]
  'outfit', // OutfitUI — items[]
  'course', // CourseUI — items[]
  'service', // ServiceUI — items[]
  'donation', // DonationUI — items[]
  'pricing', // PricingUI — items[]
  'menu', // MenuUI — items[]
  'file', // FileUI — items[]
  'booking', // BookingUI — items[]
  'page-list', // PageListUI — items[]
];
